<template>
  <div>
    <div class="header-options d-flex align-items-center cursor-pointer px-2 py-3">
      <div class="pl-2">
        <UserAvatar :width="50" @click="goProfile()" />
      </div>
      <div class="text d-flex flex-column" @click="goProfile()">
        <span class="username font-weight-bold"
          >{{ $t('profile.main.header.hi') }} {{ username }}</span
        >
      </div>
    </div>
    <div class="profile-options">
      <ul class="options">
        <li class="option cursor-pointer font-weight-light">
          <nuxt-link
            :to="localePath('profile')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon :width="iconSize" :height="iconSize" :as-original="true" icon="dashboard"
            /></span>
            <span>{{ $t('profile.navSide.sector.option') }}</span>
          </nuxt-link>
        </li>
        <li class="option cursor-pointer font-weight-light">
          <nuxt-link
            :to="localePath('profile-account')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon :width="iconSize" :height="iconSize" :as-original="true" icon="account"
            /></span>
            <span>{{ $t('profile.navSide.sector.option2') }}</span>
          </nuxt-link>
        </li>
        <li class="option cursor-pointer font-weight-light">
          <nuxt-link
            :to="localePath('profile-downloads')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon :width="iconSize" :height="iconSize" :as-original="true" icon="download"
            /></span>
            <span>{{ $t('profile.navSide.sector.option3') }}</span>
          </nuxt-link>
        </li>
        <li class="option cursor-pointer font-weight-light">
          <nuxt-link
            :to="localePath('profile-favorites')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon :width="iconSize" :height="iconSize" :as-original="true" icon="favourite"
            /></span>
            <span>{{ $t('profile.navSide.sector.option4') }}</span>
          </nuxt-link>
        </li>
        <li
          v-show="$auth.user.userPlanType === getMerch"
          class="option cursor-pointer font-weight-light"
        >
          <nuxt-link
            :to="localePath('profile-my-designs')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon :width="iconSize" :height="iconSize" :as-original="true" icon="tshirt-mockup"
            /></span>
            <span>{{ $t('profile.navSide.sector.option5') }}</span>
          </nuxt-link>
        </li>
        <li class="option cursor-pointer font-weight-light">
          <nuxt-link
            :to="localePath('profile-tools')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon :width="iconSize" :height="iconSize" :as-original="true" icon="tools"
            /></span>
            <span>{{ $t('profile.navSide.sector.option6') }}</span>
          </nuxt-link>
        </li>
        <li class="option cursor-pointer font-weight-light">
          <nuxt-link
            :to="localePath('profile-billing')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon :width="iconSize" :height="iconSize" :as-original="true" icon="credit-card"
            /></span>
            <span>{{ $t('profile.navSide.sector.option7') }}</span>
          </nuxt-link>
        </li>
        <li class="option cursor-pointer font-weight-light">
          <nuxt-link
            :to="localePath('profile-my-requests')"
            class="link d-flex align-items-center"
            @click.native="$bvModal.hide('profile-menu-modal')"
          >
            <span class="icon mr-2"
              ><Icon
                :width="iconSize"
                :height="iconSize"
                :as-original="true"
                icon="design-requests"
            /></span>
            <span>{{ $t('profile.navSide.sector.option8') }}</span>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserAvatar from 'UI/UserAvatar';
import Icon from 'UI/Icon';
export default {
  components: {
    UserAvatar,
    Icon
  },
  data() {
    return {
      iconSize: 30
    };
  },
  computed: {
    ...mapGetters('experience', ['getMerch']),
    ...mapGetters('user', ['username', 'userId'])
  },
  methods: {
    goProfile() {
      this.$bvModal.hide('profile-menu-modal');
      this.$router.push(this.localePath('profile'));
    }
  }
};
</script>

<style lang="scss" scoped>
.header-options {
  color: #747474;
  border-radius: 0px 0px 5px 5px;
  .text {
    margin-left: 10px;
    flex: 1;
    .username {
      font-size: 20px;
    }
  }
}
.option {
  padding: 8px 25px;
  list-style: none;
  font-size: 15px;
  color: $gray;
  .link {
    color: black;
  }
  &:hover {
    background: $lightGray;
  }
  &:last-child {
    padding-bottom: 10px;
  }
}
.profile-options {
  border-radius: 0px 0px 5px 5px;
  .options {
    padding: 0;
  }
}
span.icon {
  color: $gray;
  .svg-icon-container {
    display: block;
  }
}
</style>
